import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {pmpLinks} from '~/modules/Pmp';

export const PmpNavigation = () => <NavTabs tabs={[{
    children: 'Deals',
    to: pmpLinks.deals()
}, {
    children: 'Supply Packages',
    to: pmpLinks.supplyPackages()
}, {
    children: 'Sensitive Categories',
    to: pmpLinks.sensitiveCategories()
}]}/>;
